// extracted by mini-css-extract-plugin
export default {"header":"Header_header__iamXr","title":"Header_title__JvMkv"};